export default __webpack_public_path__ + "static/thumbnail-c6d75b279645b8ac48036c538015fe36.png";